import { useContext } from 'react'
import { SceneContext } from './SceneContext'
import { useHistory }  from 'react-router-dom'
import './css/Menu.css'

export default function Menu(props) {
    const context = useContext(SceneContext)
    const history = useHistory()

    const mapClick = () => {
        context.change_display_map(!context.display_map)
    }

    const changeDaylight = (daylight, abbv) => {
        const current = history.location.pathname
        const l = current.charAt(1)
        const light_enabled = (l==='M' || l==='T' || l==='N')

        if(light_enabled) {
            history.push(abbv + current.slice(2))
            context.set_daylight(daylight)
        }
    }

    const goBack = () => {
        history.goBack()
    }

    const l = history.location.pathname.charAt(1)
    const light_enabled = (l==='M' || l==='T' || l==='N')

    if (!context.require_user_click) {
        return (
            <div>
                <div className="menu">
                    <div className="menu-button menu-map-button circle" style={{marginRight:20}} onClick={mapClick}>
                        <div className="icon-wrapper"> 
                            <img className="icon" alt="" src="images/mapa/map-icon.svg" />
                        </div>
                        <div className="text-wrapper"> 
                            <div className="text">Mapa</div>
                        </div>
                    </div>

                    <div className={"menu-button menu-map-button circle fs-button"} style={{marginRight:20}} onClick={props.fullscreen}>
                        <div className={'icon-wrapper'}> 
                            <img className="icon" alt="" src={ !props.is_fs ? "images/mapa/open_fs.svg" : "images/mapa/close_fs.svg"} />
                        </div>
                    </div>

                    <div className={"menu-button manana-button circle-left " + (context.selected_scene_data?.on_back ? 'gray-off':'')} onClick={()=>changeDaylight('manana', 'M')}>
                        <div className={context.daylight !== 'manana' ? 'icon-wrapper gray' : 'icon-wrapper'}> 
                            <img className="icon" alt="" src="images/mapa/manana-icon.svg" />
                        </div>
                    </div>
                    <div className={"menu-button tarde-button " + (context.selected_scene_data?.on_back ? 'gray-off':'')} onClick={()=>changeDaylight('tarde', 'T')}>
                        <div className={context.daylight !== 'tarde' ? 'icon-wrapper gray' : 'icon-wrapper'}> 
                            <img className="icon" alt="" src="images/mapa/tarde-icon.svg" />
                        </div>
                    </div>
                    <div className={"menu-button noche-button circle-right " + (context.selected_scene_data?.on_back ? 'gray-off':'')} onClick={()=>changeDaylight('noche', 'N')}>
                        <div className={context.daylight !== 'noche' ? 'icon-wrapper gray' : 'icon-wrapper'}> 
                            <img className="icon" alt="" src="images/mapa/noche-icon.svg" />
                        </div>
                    </div>               
                </div>
            </div>
        )
    } else {
        return ''
    }
    
}